import { fetchWithRetry } from "@configs/apis/api-config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { message as messageToast } from "antd";

import { TAG_TYPES } from "../../../app.config";

messageToast.config({
  maxCount: 3,
  duration: 3,
});


export const baseApi = createApi({
  reducerPath: "baseApi",
  tagTypes: TAG_TYPES,
  baseQuery: fetchWithRetry,
  endpoints: () => ({}),
});
